import i18n from "../../util/i18n.ts";

const Info = ({
	end,
	numRows,
	numRowsUnfiltered,
	start,
}: {
	end: number;
	numRows: number;
	numRowsUnfiltered: number;
	start: number;
}) => {
	const filteredText =
		numRows !== numRowsUnfiltered
			? ` ${i18n.t("dataTable.filteredFrom", { ns: "ui", defaultValue: "(filtered from {{count}})", count: numRowsUnfiltered })}`
			: null;
	return (
		<div className="d-none d-sm-block">
			{i18n.t("dataTable.rowsInfo", {
				ns: "ui",
				defaultValue: "{{start}} to {{end}} of {{count}}",
				start: numRows === 0 ? 0 : start,
				end,
				count: numRows,
			})}
			{filteredText}
		</div>
	);
};

export default Info;
